export default __webpack_public_path__ + "static/332136cf-33d0-43fb-97ee-49c7742489ff-ae2df4552e5f927be6f9befa8d6b722e.woff";